import React from 'react';
import { ReactComponent as QuestionIcon } from '../../assets/images/global/question_icon.svg';
import './ChatHelp.styles.css';

const ChatHelp = () => {

    return(
        <div className="cm-help-btn bg-primary d-flex align-items-center justify-content-center position-absolute rounded-circle">
            <QuestionIcon />
        </div>
    )

}

export default ChatHelp;